<div class="row">
  <div class="col-12">
    <sb-card [loadingDelay]="1" [loading]=loading>
      <div card-header classes="no-border">
        <div class="row">
          <div class="col">
          </div>
        </div>
        <div class="row">
          <div class="col">
            <sb-search-bar placeholder="{{ 'lang.globals.searchPlaceholder' | translate }}"
                           searchTooltip="{{ 'lang.globals.searchPlaceholder' | translate }}"
                           stopSearchTooltip="{{ 'lang.globals.stopSearchPlaceholder' | translate }}"
                           (searchAction)="searchCampaign($event)"
                           headline="{{ 'lang.headlines.campaigns' | translate }}"
                           [subline]="paginationString" [searchStr]="search"></sb-search-bar>
          </div>
        </div>
      </div>
      <div card-header-more>
        <table class="table rearrangeCampaignPreviewShadow my-3">
          <tbody>
          <tr [ngClass]="{'tw-opacity-50' : !campaignToRearrange.active}">
            <td>
              <div class="d-flex align-items-center">
                <sb-action-required
                  class="mr-4"
                  [bookingStatus]="campaignToRearrange.bookingStatus"></sb-action-required>
                <sb-comp-image-name-wrapper [medium]="campaignToRearrange?.preview">
                  <span firstLine [innerHTML]="campaignToRearrange.name | truncate : 30"></span>
                  <sb-comp-commercial-count secondLine [commercialCount]="campaignToRearrange?.commercialCount"></sb-comp-commercial-count>
                  <span thirdLine [classes]="'d-xxxl-none'">
                    {{campaignToRearrange.customer.name}}
                  </span>
                </sb-comp-image-name-wrapper>
              </div>
            </td>
            <td class="d-xxxl-table-cell d-none">
              <span [innerHTML]="campaignToRearrange.customer.name | truncate : 23"></span>
            </td>
          </tr>
          </tbody>
        </table>
        <div class="d-flex align-items-center" *ngIf="SHOWFILTERPARAMS">
          <div class="mr-3" style="display: flex; flex: 1;">
            <div class="form-check form-switch mr-3">
              <input [disabled]="true" type="checkbox" role="switch" class="form-check-input timingPlanned"
                     id="rearrModalSwPlanned" [ngModel]="timingPlanned">
              <label class="form-check-label" for="rearrModalSwPlanned">{{'lang.globals.planned' |
                translate}}</label>
            </div>
            <div class="form-check form-switch mr-3 timingActive">
              <input [disabled]="true" type="checkbox" role="switch" class="form-check-input"
                     id="rearrModalSwActive" [ngModel]="timingActive">
              <label class="form-check-label" for="rearrModalSwActive">{{'lang.globals.running' |
                translate}}</label>
            </div>
            <div class="form-check form-switch mr-3 timingEnded">
              <input [disabled]="true" type="checkbox" role="switch" class="form-check-input" id="rearrModalSwEnded"
                     [ngModel]="timingEnded">
              <label class="form-check-label" for="rearrModalSwEnded">{{'lang.globals.expired' |
                translate}}</label>
            </div>
            <div class="form-check form-switch mr-3 timingUnknown">
              <input [disabled]="true" type="checkbox" role="switch" class="form-check-input"
                     id="rearrModalSwUnknown" [ngModel]="timingUnknown">
              <label class="form-check-label" for="rearrModalSwUnknown">{{'lang.globals.noTiming' |
                translate}}</label>
            </div>
          </div>
        </div>
      </div>
      <div card-fit>
        <ng-scrollbar style="height: 560px;" [track]="'vertical'">
          <div class="row">
            <div class="col">
              <sb-ghost-list [ghosts]="ghosts"></sb-ghost-list>
              <div *ngIf="campaigns">
                <table class="w-100">
                  <thead>
                  <tr>
                    <th class="pl-4">
                      {{'lang.globals.arrangement' | translate}}
                    </th>
                    <th class="">
                      {{'lang.globals.campaign' | translate}}
                    </th>
                    <th class="d-xxxl-table-cell d-none">{{'lang.globals.customer' | translate}}
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <ng-container *ngFor="let campaign of campaigns; index as i; last as last">
                    <tr>
                      <td colspan="3" class="text-center resizeTdbefore">
                        <div class="placementbox cursor-pointer" ngbTooltip="{{'lang.globals.placeHere' | translate}}"
                             container="body" placement="top" (click)="putBefore(campaign)">
                        </div>
                      </td>
                    </tr>
                    <tr
                      [ngClass]="{'tw-opacity-50' : !campaign.active, 'tw-opacity-20' : campaign.id === campaignToRearrange.id}">
                      <td class="pl-4"><span class="font-weight-bold">{{campaign?.clientOrderNum}}</span>
                      </td>
                      <td>
                        <div class="d-flex align-items-center">
                          <sb-action-required class="mr-4"
                                              [bookingStatus]="campaign.bookingStatus"></sb-action-required>
                          <sb-comp-image-name-wrapper [medium]="campaign?.preview">
                            <span firstLine [innerHTML]="campaign.name | truncate : 23"></span>
                            <sb-comp-commercial-count secondLine [commercialCount]="campaign?.commercialCount"></sb-comp-commercial-count>
                            <span thirdLine [classes]="'d-xxxl-none'">{{campaign.customer.name}}</span>
                          </sb-comp-image-name-wrapper>
                        </div>
                      </td>
                      <td class="d-xxxl-table-cell d-none">
                        <span [innerHTML]="campaign.customer.name | truncate : 23"></span>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="3" class="text-center resizeTdafter">
                        <div class="placementbox cursor-pointer" ngbTooltip="{{'lang.globals.placeHere' | translate}}"
                             container="body" placement="top" (click)="putAfter(campaign)">
                        </div>
                      </td>
                    </tr>
                  </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </ng-scrollbar>
      </div>
      <div card-footer>
        <div sb-pagination *ngIf="paginationInitialized" [collectionSize]="collectionSize" [(page)]="page"
             (pageChange)="pageChange($event)" [maxSize]="maxSize" [boundaryLinks]="boundaryLinks">
        </div>
      </div>
    </sb-card>
  </div>
</div>
